var map = {
	"./ClassSoftware.svg": "7ykv",
	"./anquan.svg": "yqot",
	"./class.svg": "f1+m",
	"./home.svg": "GU1v",
	"./mima.svg": "qz29",
	"./mine.svg": "AsYQ",
	"./mockResult.svg": "e3Lh",
	"./mockTest.svg": "uX8v",
	"./myxiaoxi.svg": "iv93",
	"./onlineStudy.svg": "wiZv",
	"./paihang.svg": "lmtP",
	"./personal.svg": "bQZw",
	"./studyMsg.svg": "pg9l",
	"./teachManage.svg": "hQaH",
	"./trainClassManage.svg": "f0z/",
	"./wx.svg": "jHJp",
	"./yonghuming.svg": "qi4b",
	"./zfb.svg": "bIkZ"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "VZYf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/svg nonrecursive \.svg$
// module id = VZYf
// module chunks = 9